import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useAuthUser } from "react-auth-kit";
import { Box, Text, Title } from "@mantine/core";
import { AuthForm } from "../components";
import { FlexAllCenter } from "../styles/sx-mixins";
import { BrandLogo } from "../components/SvgAssets";


const AuthPage = () => {
	const session = useAuthUser();
	const navigate = useNavigate();

	useEffect(() => {
		if (session()?.token) navigate("/bills/");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [session]);

	return (
		<Box component="main" sx={{ display: "flex", fontFamily: "Montserrat, sans-serif", color: "#272727" }}>
			{/* left side fixed background image */}
			<Box
				sx={{
					position: "relative",
					width: "55%",
					"@media (max-width: 960px)": {
						width: "45%",
					},
					"@media (max-width: 720px)": {
						display: "none",
					},
					height: "100vh",
					zIndex: -1,
				}}
			>
				<Box sx={{ position: "fixed", top: 0, left: 0, bottom: 0, width: "inherit" }}>
					<img loading="lazy" src="/assets/auth-bg.png" alt="Background" height="100%" />
				</Box>
			</Box>

			<Box
				sx={{
					...FlexAllCenter,
					width: "45%",
					minHeight: "100vh",
					"@media (max-width: 960px)": {
						width: "55%",
					},
					"@media (max-width: 720px)": {
						width: "100%",
					},
				}}
			>
				<Box
					sx={{
						maxWidth: "450px",
						padding: "28px 34px",
					}}
				>
					<Box sx={{ width: "205px", height: "50px", marginBottom: "10px" }}>
						<BrandLogo />
					</Box>

					<Box sx={{ marginBottom: "11.5px" }}>
						<Title
							order={2}
							sx={{
								fontSize: "24px",
								fontWeight: 700,
								marginBottom: "5px",
								lineHeight: "30px",
								letterSpacing: "0.3px",
							}}
						>
							Find the representatives that best represent you.
						</Title>
						<Text sx={{ fontSize: "14px", opacity: 0.85 }}>Sign up to begin building your personal VoterScore today.</Text>
					</Box>

					<AuthForm />
				</Box>
			</Box>
		</Box>
	);
};

export default AuthPage;
